import { getStatusColor } from '../../appointment/appointmentFunctions';

const AppointmentStatusBadge = ({ status }) => {

    return (
        <span className={`px-3 py-1 rounded-full text-xs font-medium ${getStatusColor(status)}`}>
            {status}
        </span>
    );
};

export default AppointmentStatusBadge;
